import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import Typography from '../../common/Typography';
import PolicyText from '../../common/PolicyText';
import Button from '../../common/Button';
import InputComponent from '../InputComponent';
import { titleName } from '../constants';

const Container = styled.div`
  margin: 0px auto 0px;
  padding: 10px 0px 40px;
  width: ${({ mobile }) => (mobile ? '100%' : '706px')};
  background-color: white;
`;
const Section = styled.section`
  border-bottom: 2px dashed ${({ theme }) => theme.colors.Neutral[200]};
  &:last-of-type {
    border: none;
  }
  margin-bottom: 20px;
  padding: 20px ${({ mobile }) => (mobile ? '30px' : '45px')};
`;
const Heading = styled(Typography)`
  margin-bottom: 25px;
`;
const ButtonSubmit = styled(Button)`
  border: none;
  min-width: 300px;
  margin: 0px 40px;
  @media (max-width: 767px) {
    margin: 0 auto;
  }
`;
const Policy = styled(PolicyText)`
  margin: 10px 40px;
`;
const PostAdTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.TextBeta};
  padding-top: 10px;
`;
const Title = styled.div`
  padding: ${({ mobile }) => (mobile ? '30px' : '20px 45px 40px')};
  border-bottom: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
  margin-bottom: 10px;
`;
const ChangeSubCategory = styled(Typography)`
  color: ${({ theme }) => theme.colors.Primary};
`;

const PostAdPage = ({
  data: { sections, title, meta } = {},
  titleEnabled = true,
  isMobile,
  onSubmitClick,
  submitText,
  loginStats = {},
  isEditAd,
  subcategory,
  loadDynamicOptions,
  fireGa,
  className,
  inputState,
  setInputState,
  loading
}) => {
  const { getValues } = useFormContext();
  const [childOptions, setChildOptions] = useState({});

  const handleEdit = ({ id, is_editable, component }) => {
    const value = getValues(id);
    if (
      (!isEditAd && loginStats.loggedIn && Object.keys(loginStats.user.user).includes(id)) ||
      component === 'postfilled'
    ) {
      return true;
    }
    return isEditAd ? !is_editable : false;
  };

  return (
    <Container mobile={isMobile} className={className}>
      {titleEnabled && (
        <Title mobile={isMobile}>
          <h1 className="h1">{title}</h1>
          {!isEditAd && (
            <PostAdTitle className="dB" tagName="span">
              All categories / {titleName[subcategory]} &nbsp;&nbsp;
              <ChangeSubCategory
                tagName="a"
                className="dIB"
                href="/post-classifieds-ads/select-category/"
              >
                Change
              </ChangeSubCategory>
            </PostAdTitle>
          )}
        </Title>
      )}
      {sections.map(section => {
        return (
          <Section mobile={isMobile} key={section.heading}>
            <Heading
              tagName={titleEnabled ? 'h3' : 'h2'}
              modifiers={titleEnabled ? ['h3', 'medium'] : ['h2', 'medium']}
            >
              {section.heading}
            </Heading>
            {(section.fragments || []).map(({ id, ...restAttr }) => {
              return (
                <InputComponent
                  key={id}
                  id={id}
                  isMobile={isMobile}
                  inputState={inputState}
                  setInputState={setInputState}
                  disabled={handleEdit({ id, ...restAttr })}
                  fireGa={fireGa}
                  subcategory={subcategory}
                  setChildOptions={setChildOptions}
                  childOptions={childOptions}
                  loadDynamicOptions={loadDynamicOptions}
                  {...restAttr}
                />
              );
            })}
          </Section>
        );
      })}
      <ButtonSubmit
        className="fwB dB"
        onClick={onSubmitClick}
        btnType="postAd"
        shadow
        size="lg"
        type="button"
        loading={loading}
      >
        {submitText}
      </ButtonSubmit>
      <Policy className="taL" />
    </Container>
  );
};

PostAdPage.propTypes = {
  isEditAd: PropTypes.bool,
  isMobile: PropTypes.bool,
  titleEnabled: PropTypes.bool,
  subcategory: PropTypes.string,
  submitText: PropTypes.string,
  data: PropTypes.object,
  loginStats: PropTypes.object,
  onSubmitClick: PropTypes.func,
  loadDynamicOptions: PropTypes.func,
  fireGa: PropTypes.func,
  className: PropTypes.string,
  inputState:PropTypes.object,
  setInputState:PropTypes.func,
  loading:PropTypes.bool
};
export default PostAdPage;
